import ListProducers from "@/views/service_provider/tech_visits/producer_inspectors/ListProducers.vue";
import NewProducerInspector from "@/views/service_provider/tech_visits/producer_inspectors/NewProducerInspector.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "sp",
  role: "tech_visits",
  permission: "producer_inspectors",
});

export default [
  {
    path: "/sp/:service_provider_id/tech_visits/producer_inspectors",
    name: routeName(""),
    component: ListProducers,
    props: true,
    meta: META
  },
  {
    path: "/sp/:service_provider_id/tech_visits/producer_inspectors/new/:inspector_id",
    name: routeName("new"),
    component: NewProducerInspector,
    props: true,
    meta: META
  }
];
